<template>
    <div class="project-page body-box">
        <div class="hero-header">
            <h3 class="title-with-dot">{{ headerTitle }}</h3>
        </div>

		<div class="project-content-body">
			<div class="project-content-body-inner">
					
				<h1>{{ sectionTitle }}</h1>
				<p>{{ sectionDescription }}</p>

            </div>



            <div class="projects-list">
                <project-item :item="project" v-for="(project, i) in projects" :key="i" />
            </div>
			<div class="project-content-body-inner project-content-body-inner2">
					
				<h1>{{ title }}</h1>
				<p>{{ content }}</p>

            </div>

            <products-section />

            <news-letter />

            <ohilo-footer />
            
        </div>

    </div>
</template>

<script>
import ProjectItem from '@/components/modules/ProjectItem.vue';
import ProductsSection from '@/components/sections/ProductsSection.vue';
import NewsLetter from '@/components/sections/NewsLetter.vue';
import OhiloFooter from '@/components/common/OhiloFooter.vue';

export default {
    name: 'ProjectView',
    components: {
        ProjectItem,
        ProductsSection,
        NewsLetter,
        OhiloFooter,
    },
    data() {
        return {
            headerTitle: 'Projects',
            sectionTitle: 'My Works',
            sectionDescription: 'Discover my portfolio, where purposeful interfaces meet captivating design. My work strives to enhance experiences and inspire.',
            title: 'Explore My Products',
            content: 'some of the digital products that I worked on as side projects, explore them now',
            projects: [
                {
                    img: require('@/assets/images/project1.jpg'),
                    title: 'Seven Studio',
                    description: 'Product Design, Logo Design'
                },
                {
                    img: require('@/assets/images/project2.jpg'),
                    title: 'Raven Studio',
                    description: 'Branding, Product Design, Logo Design'
                },
                {
                    img: require('@/assets/images/project3.jpg'),
                    title: 'Dynamic',
                    description: 'Web Designing, Logo Design'
                },
                {
                    img: require('@/assets/images/project1.jpg'),
                    title: 'Seven Studio',
                    description: 'Product Design, Logo Design'
                },
                {
                    img: require('@/assets/images/project2.jpg'),
                    title: 'Raven Studio',
                    description: 'Branding, Product Design, Logo Design'
                },
                {
                    img: require('@/assets/images/project3.jpg'),
                    title: 'Dynamic',
                    description: 'Web Designing, Logo Design'
                }
            ]
        }
    }
}
</script>